import { RobotOutlined } from "@ant-design/icons";
import Button, { ButtonProps } from "@/shared/form/button";

export function AiButton(props: ButtonProps) {
  return (
    <Button
      icon={<RobotOutlined />}
      type={"primary"}
      size={"small"}
      {...props}
    />
  );
}
